/**
 * companyUserLive: batch read + merge for Phase 1 (aligned with MigrationDataAccessLayer).
 * Use wherever companyUsers docs are read without the DAL but location/status must stay current.
 */

import {
  collection,
  documentId,
  getDocs,
  query,
  where,
  type Firestore,
} from 'firebase/firestore';
import {
  FIRESTORE_COLLECTIONS,
  COMPANY_USER_LIVE_FIELD_KEYS,
} from '../constants/firestoreCollections';

export function mergeCompanyUserLiveIntoSnapshot(
  base: Record<string, unknown>,
  live: Record<string, unknown> | undefined | null
): Record<string, unknown> {
  const out = { ...base };
  if (!live) return out;
  for (const k of COMPANY_USER_LIVE_FIELD_KEYS) {
    if (live[k] !== undefined) {
      out[k] = live[k];
    }
  }
  return out;
}

export async function fetchCompanyUserLiveMap(
  db: Firestore,
  userIds: string[]
): Promise<Map<string, Record<string, unknown>>> {
  const map = new Map<string, Record<string, unknown>>();
  const ids = userIds.filter(Boolean);
  for (let i = 0; i < ids.length; i += 30) {
    const chunk = ids.slice(i, i + 30);
    const q = query(
      collection(db, FIRESTORE_COLLECTIONS.COMPANY_USER_LIVE),
      where(documentId(), 'in', chunk)
    );
    const snap = await getDocs(q);
    snap.docs.forEach((d) => map.set(d.id, d.data() as Record<string, unknown>));
  }
  return map;
}
